import _Popconfirm from './Popconfirm';

import './style/index.js';

export type { PopconfirmProps } from './Popconfirm';
export * from './type';

export const Popconfirm = _Popconfirm;
export default Popconfirm;
